export default {"src":"/_next/static/media/GromologoWhite.e40777f3.svg","height":152,"width":453};